import type { Step } from 'react-joyride';
import { AppRoutes } from '../../types/constants.types';

export const OWNER_TOUR_START_EVENT = 'owner-tour:start';

export interface OwnerTourStep extends Step {
  /** Page the step lives on. Steps without a route stay wherever the owner currently is. */
  data?: { route?: string };
}

const pageHeader = (route: string) => `[data-tour="page-header"][data-tour-path="${route}"]`;

export const OWNER_TOUR_STEPS: OwnerTourStep[] = [
  {
    target: 'body',
    placement: 'center',
    disableBeacon: true,
    title: 'Welcome to your Tap2Feed dashboard',
    content:
      'Your channel is set up. This short tour (about two minutes) shows where to track your impact, share your channel and get paid. You can leave at any time and pick up again later.',
  },
  {
    target: '[data-tour="sidebar"]',
    placement: 'right',
    disableBeacon: true,
    title: 'Everything starts here',
    content:
      'Use the menu to move between your performance, channel settings, social posts, rewards and support. The menu stays in view on every page.',
  },
  {
    target: pageHeader(AppRoutes.KIOSK_PERFORMANCE),
    placement: 'bottom',
    disableBeacon: true,
    title: 'Your impact at a glance',
    content:
      'Kiosk Performance shows donations, FOOD bars delivered and trends for your channel, with live and historical reporting.',
    data: { route: AppRoutes.KIOSK_PERFORMANCE },
  },
  {
    target: pageHeader(AppRoutes.KIOSKS),
    placement: 'bottom',
    disableBeacon: true,
    title: 'Share your channel',
    content:
      'Your channel, with its web link, QR code and TV-format link, lives under Kiosks. Copy or download them and start sharing: every tap is real food for real people.',
    data: { route: AppRoutes.KIOSKS },
  },
  {
    target: pageHeader(AppRoutes.KIOSK_CONFIGURATION),
    placement: 'bottom',
    disableBeacon: true,
    title: 'Make the channel yours',
    content:
      'In the Kiosk CMS you control your name, logo, messages and donation amounts. Changes may be reviewed by the E2G FOOD team before they go live.',
    data: { route: AppRoutes.KIOSK_CONFIGURATION },
  },
  {
    target: pageHeader(AppRoutes.SOCIAL_MEDIA_CAMPAIGN),
    placement: 'bottom',
    disableBeacon: true,
    title: 'Ready-made posts to share',
    content:
      'Social Media has ready-to-share messages. Copy one, post it today, and every time you post another person gets fed.',
    data: { route: AppRoutes.SOCIAL_MEDIA_CAMPAIGN },
  },
  {
    target: pageHeader(AppRoutes.OWNER_REPORTING_PAYOUT_SETTINGS),
    placement: 'bottom',
    disableBeacon: true,
    title: 'Set up your bank account',
    content:
      'In Account Settings, add your bank details so rewards can be paid to you, and choose how often you want donation reports: live, weekly or monthly.',
    data: { route: AppRoutes.OWNER_REPORTING_PAYOUT_SETTINGS },
  },
  {
    target: pageHeader(AppRoutes.OWNER_REWARDS),
    placement: 'bottom',
    disableBeacon: true,
    title: 'Track and redeem your rewards',
    content:
      'Rewards shows what your channel has earned and lets you redeem it as cash or as FOOD bars donated to an E2G FOOD campaign.',
    data: { route: AppRoutes.OWNER_REWARDS },
  },
  {
    target: pageHeader(AppRoutes.SUPPORT_REQUESTS),
    placement: 'bottom',
    disableBeacon: true,
    title: 'We are here to help',
    content: 'Open a support request any time and our team will get back to you. You can attach screenshots or short videos.',
    data: { route: AppRoutes.SUPPORT_REQUESTS },
  },
  {
    target: 'body',
    placement: 'center',
    disableBeacon: true,
    title: 'You are ready to go',
    content:
      'Finish the "Getting started" checklist on the right of your screen, starting with your bank account. You can replay this tour any time from "Product tour" at the bottom of the menu.',
    data: { route: AppRoutes.KIOSK_PERFORMANCE },
  },
];
